import BLEIcon from '@/assets/StakingtoEarn/icon_BLE.svg'
import BLPIcon from '@/assets/StakingtoEarn/icon_BLP.svg'
import OtherIcon from '@/assets/StakingtoEarn/icon_Other.svg'
import BTCIcon from '@/assets/coin/btc_logo.svg'
import ETHIcon from '@/assets/coin/eth_logo.svg'
import USDIcon from '@/assets/coin/usd_logo.svg'
import USDCIcon from '@/assets/coin/usdc_logo.svg'
import USDTIcon from '@/assets/coin/usdt_logo.svg'
import AvaxIcon from '@/assets/ic_avalanche_24.svg'

export const CoinIconMap: Record<string, string> = {
  ETH: ETHIcon,
  BTC: BTCIcon,
  USDC: USDCIcon,
  USDT: USDTIcon,
  USD: USDIcon,
  AVAX: AvaxIcon,
  BLE: BLEIcon,
  BLP: BLPIcon,
  Other: OtherIcon,
}
